/* __next_internal_client_entry_do_not_use__ Breadcrumbs auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import * as React from "react";
import styled, { useTheme } from "styled-components";
import { Option } from "./Option";
var BreadcrumbRow = styled.ol.withConfig({
    componentId: "sc-90bb9137-0"
})([
    "line-height:16px;padding:16px;margin:0;list-style-type:none;li{display:inline-block;padding-right:4px;}"
]);
/**
 * @trackcomponent
 * @link [Docs](https://slate.faire.team/component/breadcrumb)
 */ export var Breadcrumbs = function(param) {
    var className = param.className, options = param.options, handleOnClick = param.handleOnClick, dataTestId = param.dataTestId, _ariaLabel = param.ariaLabel;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var ariaLabel = _ariaLabel || strictLocalize({
        id: "2ezgqJ",
        defaultMessage: [
            {
                type: 0,
                value: "Breadcrumbs"
            }
        ]
    });
    var theme = useTheme();
    return /*#__PURE__*/ _jsx("nav", {
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ _jsx(BreadcrumbRow, {
            className: className,
            "data-test-id": dataTestId,
            itemScope: true,
            itemType: "https://schema.org/BreadcrumbList",
            children: options.map(function(optionData, index) {
                return /*#__PURE__*/ _jsx(Option, {
                    optionData: optionData,
                    index: index,
                    handleOnClick: handleOnClick,
                    isLastIndex: index === options.length - 1,
                    theme: theme
                }, index);
            })
        })
    });
};
